import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';

import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import ContactRow from './ContactRow.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const { SetNotification } = useStateContext();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [contactsPerPage] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/anycontacts');
        setContacts(response.data.reverse());
        
        setLoading(false);
      } catch (error) {
        console.error(error);
        SetNotification('Error fetching data', 'danger');
      }
    };
    fetchData();
  }, [SetNotification]);

  const handleDeleteContact = async (id) => {
    try {
      await AxiosClient.delete(`/anycontacts/${id}`);
      setContacts(contacts.filter((contact) => contact.id !== id));
      SetNotification('A contact has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the contact', 'danger');
    }
  };

  // Get current contacts
  const indexOfLastContact = currentPage * contactsPerPage;
  const indexOfFirstContact = indexOfLastContact - contactsPerPage;
  const currentContacts = contacts.slice(indexOfFirstContact, indexOfLastContact);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="card-body px-0 pb-2 p-2">
      <div className="p-0">
        {loading ? (
          <Loader label="Loading contacts..." />
        ) : (
          <>
            {currentContacts.map((contact) => (
              <ContactRow
                key={contact.id}
                name={contact.name}
                email={contact.email}
                message={contact.message}
                id={contact.id}
                onDelete={handleDeleteContact}
              />
            ))}
          </>
        )}
      </div>
      <nav>
        <ul className="pagination m-2 p-2">
          {Array.from({ length: Math.ceil(contacts.length / contactsPerPage) }).map((_, index) => (
            <li key={index} className={`page-item m-2 ${currentPage === index + 1 ? 'font-bold' : ''}`}>
              <button className="page-link" onClick={() => paginate(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Contacts;